import { AccountMenu } from "@modules:AccountMenu";
import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

type HeaderProps = {
  rightSide?: ReactNode;
  leftSide?: ReactNode;
  sx?: SxProps<Theme>;
};

export const Header = ({ rightSide, sx = {}, leftSide }: HeaderProps) => {
  return (
    <Box
      sx={{
        zIndex: 10,
        position: "sticky",
        top: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "4rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          {leftSide}
        </Box>
        <Box
          display="flex"
          alignItems="center"
          sx={{
            marginLeft: "auto",
          }}
        >
          {rightSide}
          <AccountMenu
            sx={{
              marginLeft: "auto",
              paddingRight: "1rem",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
